// API Configuration with Runtime Support

let runtimeConfig: { API_BASE_URL?: string } = {};

/**
 * Loads runtime config from /config.json. Call this before rendering the app (in main.tsx).
 */
export const loadRuntimeConfig = async () => {
  try {
    const res = await fetch('/config.json');
    runtimeConfig = await res.json();
  } catch (e) {
    // If config.json is missing, fallback to default
    runtimeConfig = {};
  }
};

/**
 * Returns the API base URL from runtime config, or fallback to default.
 */
export const getApiBaseUrl = () => {
 /*return 'http://localhost:5165/api';*/
  return 'https://epathshala.winitsoftware.com/webapiv1/api';
};

export const API_CONFIG = {
  get BASE_URL() {
    return getApiBaseUrl();
  },
  ENDPOINTS: {
    AUTH: {
      LOGIN: '/Auth/ValidateUser',
      VALIDATE: '/Auth/ValidateToken',
      LOGOUT: '/Auth/Logout',
    },
    MODULES: {
      BASE: '/modules',
      BY_ID: (id: string) => `/modules/${id}`,
      SELLER_MAPPING: (id: string) => `/modules/${id}/sellers`,
      MARKUP: (id: string) => `/modules/${id}/markup`,
    },
    DASHBOARD: {
      DETAILS: '/PortalDashboard/GetPortalDashboardDetails',
    },
    USERS: {
      BASE: '/users',
      BY_ID: (id: string) => `/users/${id}`,
    }
  },
  HEADERS: {
    'Content-Type': 'application/json',
  },
} as const;

export const getApiUrl = (endpoint: string) => `${getApiBaseUrl()}${endpoint}`;

// Type for API response
export interface ApiResponse<T> {
  data: T;
  status: number;
  message: string;
}

// Type for API error
export interface ApiError {
  message: string;
  status: number;
  errors?: Record<string, string[]>;
}

// Module Types
export type ModuleType = 'Top' | 'SmallChannel';
export type PriorityType = 'High' | 'Medium' | 'Low';

export interface Question {
  id?: string;
  questionText: string;
  sequence: number;
  mediaFile?: File;
  options: {
    sequence: number;
    text: string;
    isCorrect: boolean;
  }[];
}

export interface ModuleContent {
  videoFile?: File;
  points: number;
  questions: Question[];
}

export interface Module {
  id?: string;
  title: string;
  description: string;
  startDate: string;
  endDate: string;
  assignTo: ModuleType;
  sequence: number;
  priority: PriorityType;
  reels: ModuleContent;
  classroomTraining: ModuleContent;
  inMarketMockup: {
    data: any[]; // Replace with actual type when available
  };
  createdAt?: string;
  updatedAt?: string;
} 